module.exports = __webpack_public_path__ + "static/finalist seal_NSW_Best Independent Office-1fb6ef5cfd19b42b9ae77fc93f25d99d.png";